import { get, post, put, del } from './apiClient';

export type ConfigMode = 'default' | 'development' | 'staging' | 'production' | 'demo' | 'qa' | 'uat';

export interface ServiceConfig {
    _id: string;
    serviceId?: string;
    serviceName?: string;
    mode: ConfigMode;
    subscribedTopics?: string[];
    // All other config sections stored as raw JSON
    [key: string]: any;
    createdAt: string;
    updatedAt: string;
}

export interface ServiceConfigCreate {
    serviceId?: string;
    serviceName?: string;
    mode: ConfigMode;
    subscribedTopics?: string[];
    [key: string]: any;
}

export interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

// Returns the canonical service identifier from a config document
export function resolveServiceId(cfg: Pick<ServiceConfig, 'serviceId' | 'serviceName'>): string {
    return cfg.serviceId || cfg.serviceName || '(unnamed)';
}

// Well-known service IDs for the dropdown
export const KNOWN_SERVICES = [
    'global',
    'ai',
    'app-definition',
    'authorization',
    'audit-trail',
    'contracts-provider',
    'documents',
    'identity-provider',
    'notifications',
    'objects-provider',
    'partners-provider',
    'reporting',
    'webbffui',
    'workflow',
];

export const MODES: ConfigMode[] = ['default', 'development', 'staging', 'production', 'demo', 'qa', 'uat'];

export const getAllServiceConfigs = (): Promise<ApiResponse<ServiceConfig[]>> =>
    get<ApiResponse<ServiceConfig[]>>('/service-configs');

export const getServiceConfigById = (id: string): Promise<ApiResponse<ServiceConfig>> =>
    get<ApiResponse<ServiceConfig>>(`/service-configs/${id}`);

export const createServiceConfig = (data: ServiceConfigCreate): Promise<ApiResponse<ServiceConfig>> =>
    post<ApiResponse<ServiceConfig>>('/service-configs', data);

export const updateServiceConfig = (id: string, data: Partial<ServiceConfigCreate>): Promise<ApiResponse<ServiceConfig>> =>
    put<ApiResponse<ServiceConfig>>(`/service-configs/${id}`, data);

export const deleteServiceConfig = (id: string): Promise<ApiResponse<{ message: string }>> =>
    del<ApiResponse<{ message: string }>>(`/service-configs/${id}`);
